import React, { useState } from 'react';
import { motion } from 'motion/react';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import ShimmerOverlay from './ShimmerOverlay';

const CTAButton = ({ className = '', children, style, ...props }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: 'spring', stiffness: 400, damping: 17 }}
      className="inline-flex"
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
    >
      <PrimaryButton
        className={`group relative overflow-hidden ${className}`}
        style={{
          background: 'var(--accent-primary)',
          color: '#fff',
          boxShadow:
            '0 2px 8px rgba(127, 184, 232, 0.25), 0 4px 16px rgba(127, 184, 232, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.2), inset 0 -1px 0 rgba(0, 0, 0, 0.1)',
          border: 'none',
          ...style,
        }}
        {...props}
      >
        <div
          aria-hidden
          className="absolute inset-0 opacity-0 transition-opacity duration-300 pointer-events-none group-hover:opacity-30"
          style={{ background: 'radial-gradient(circle, rgba(255, 255, 255, 0.25), transparent 70%)' }}
        />
        <ShimmerOverlay active={hovered} />
        <span className="relative z-10 flex items-center gap-2">{children}</span>
      </PrimaryButton>
    </motion.div>
  );
};

export const DualCTASection = ({
  primaryText = 'Become a Seller',
  secondaryText = 'Find Local Food',
  onPrimaryClick,
  onSecondaryClick,
  className = '',
}) => (
  <div className={`flex flex-col gap-4 sm:flex-row ${className}`}>
    <CTAButton size="lg" onClick={onPrimaryClick}>
      {primaryText}
    </CTAButton>
    <SecondaryButton size="lg" onClick={onSecondaryClick}>
      {secondaryText}
    </SecondaryButton>
  </div>
);

export default CTAButton;
